import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class FeedbackStatusSFSyncService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(public httpClient: HttpClient) { }

  getData() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackStatusSFSyncAPI/GetData`);
  }


  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/feedback-status-sf-sync.service.ts